var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"ui-select-button-list-item",class:{
    selected: _vm.selected
  },attrs:{"aria-selected":_vm.selected,"id":(_vm.id + "-item-" + (_vm.item.value)),"data-item-value":_vm.item.value,"role":"option"}},[_vm._t("item",function(){return [_vm._v(" "+_vm._s(_vm.item.text)+" ")]},{"item":_vm.item})],2)}
var staticRenderFns = []

export { render, staticRenderFns }